import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Container,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Form,
  Button,
  FormFeedback,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import classnames from "classnames";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link, useParams, useHistory } from "react-router-dom";

// Actions
import { userUpdate } from "store/actions";
import { getUserDetail } from "connection/backend";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const UserUpdate = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const redirect = () => {
    history.push("/users");
  };

  //Se utiliza una función asíncrona para traer los datos del usuario a actualizar y cargarlos en el formulario sin redux porque no es necesario
  const getData = async (id) => {
    const response = await getUserDetail(id);
    const data = response.data;
    setFormData1({
      username: data.username,
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      phone_number: data.phone,
      group: data.group,
      is_active: data.is_active.toString(),
    });
  };

  //Como lleva una arreglo de dependencias vacío ejecuta solo la primera vez que se renderiza el componente
  useEffect(() => {
    getData(id);
  }, []);

  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [formData1, setFormData1] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    group: "",
    is_active: "",
  });

  const {
    username,
    first_name,
    last_name,
    email,
    phone_number,
    group,
    is_active,
  } = formData1;

  const onChange1 = (e) => {
    setFormData1({ ...formData1, [e.target.name]: e.target.value });
  };

  const onSubmit1 = (e) => {
    e.preventDefault();
    dispatch(userUpdate(id, formData1));
  };

  const [formData2, setFormData2] = useState({
    password: "",
    confirm_password: "",
  });

  const { password, confirm_password } = formData2;

  const onChange2 = (e) => {
    setFormData2({ ...formData2, [e.target.name]: e.target.value });
  };

  const onSubmit2 = (e) => {
    e.preventDefault();
    dispatch(userUpdate(id, formData2));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Usuarios </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Usuarios"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.userUpdated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  Los datos del usuario <b>{props.userUpdated.username}</b> se
                  han actualizado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-0 font-size-20">Actualizar usuario</h2>
                </CardTitle>
                <CardBody>
                  <Row className="justify-content-md-center">
                    <Col lg={10}>
                      <Nav
                        tabs
                        justified
                        className="nav-tabs-custom"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames({
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              toggle("1");
                            }}
                          >
                            <i className="mdi mdi-account-circle-outline font-size-20"></i>
                            <span className="d-none d-sm-block">
                              Información
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames({
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              toggle("2");
                              setFormData2({
                                password: "",
                                confirm_password: "",
                              });
                            }}
                          >
                            <i className="mdi mdi-lock-outline font-size-20"></i>
                            <span className="d-none d-sm-block">
                              Contraseña
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent className="p-4" activeTab={activeTab}>
                        <TabPane id="about" role="tabpanel" tabId="1">
                          <Form onSubmit={onSubmit1}>
                            <Row className="justify-content-md-center">
                              <Col lg={10}>
                                <p>Datos personales</p>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={5}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-id-card bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      placeholder="Nombres"
                                      name="first_name"
                                      id="first_name"
                                      value={first_name}
                                      onChange={onChange1}
                                      {...(props.error && {
                                        ...(props.error.first_name
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {props.error.first_name}
                                    </FormFeedback>
                                    <Label for="firstname">Nombres</Label>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={5}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-id-card bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      placeholder="Apellidos"
                                      name="last_name"
                                      id="last_name"
                                      value={last_name}
                                      onChange={onChange1}
                                      {...(props.error && {
                                        ...(props.error.last_name
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {props.error.last_name}
                                    </FormFeedback>
                                    <Label for="lastname">Apellidos</Label>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={5}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-envelope bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="email"
                                      className="form-control"
                                      placeholder="Email"
                                      name="email"
                                      id="email"
                                      value={email}
                                      onChange={onChange1}
                                      {...(props.error && {
                                        ...(props.error.email
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {props.error.email}
                                    </FormFeedback>
                                    <Label for="email">Email</Label>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={5}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-phone bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="tel"
                                      className="form-control"
                                      placeholder="Teléfono"
                                      name="phone_number"
                                      id="phone_number"
                                      value={phone_number}
                                      onChange={onChange1}
                                      {...(props.error && {
                                        ...(props.error.phone_number
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {props.error.phone_number}
                                    </FormFeedback>
                                    <Label for="phone">Teléfono</Label>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={10}>
                                <hr></hr>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={10}>
                                <p>Datos de la cuenta</p>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={5}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-user-circle bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      placeholder="Usuario"
                                      name="username"
                                      id="username"
                                      value={username}
                                      onChange={onChange1}
                                      {...(props.error && {
                                        ...(props.error.username
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {props.error.username}
                                    </FormFeedback>
                                    <Label for="username">Usuario</Label>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id="group"
                                    name="group"
                                    value={group}
                                    onChange={onChange1}
                                  >
                                    <option value="Gerencia">Gerencia</option>
                                    <option value="Recaudo">Recaudo</option>
                                    <option value="Veterinario">
                                      Veterinario
                                    </option>
                                  </select>
                                  <Label for="group">Rol</Label>
                                </div>
                              </Col>
                              <Col lg={2}>
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id="is_active"
                                    name="is_active"
                                    value={is_active}
                                    onChange={onChange1}
                                  >
                                    <option value="false">Inactivo</option>
                                    <option value="true">Activo</option>
                                  </select>
                                  <Label for="is_active">Estado</Label>
                                </div>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mt-4 ms-5">
                              <Col lg={4}>
                                <Link
                                  className="btn btn-danger me-4"
                                  to="/users"
                                >
                                  Cancelar
                                </Link>

                                <Button color="success" type="submit">
                                  Actualizar
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>
                        <TabPane id="tasks" role="tabpanel" tabId="2">
                          <Form onSubmit={onSubmit2}>
                            <Row className="justify-content-md-center">
                              <Col lg={10}>
                                <p>Datos de la cuenta</p>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={6}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-lock-alt bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="password"
                                      className="form-control"
                                      placeholder="Contraseña"
                                      name="password"
                                      id="password"
                                      value={password}
                                      onChange={onChange2}
                                      {...(props.error && {
                                        ...(props.error.password
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {props.error.password}
                                    </FormFeedback>
                                    <Label for="password">Contraseña</Label>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center">
                              <Col lg={6}>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">
                                    <i className="bx bx-lock-alt bx-sm" />
                                  </span>
                                  <div className="form-floating">
                                    <Input
                                      type="password"
                                      className="form-control"
                                      placeholder="Confirmar contraseña"
                                      name="confirm_password"
                                      id="confirm_password"
                                      value={confirm_password}
                                      onChange={onChange2}
                                      {...(props.error && {
                                        ...(props.error.confirm_password
                                          ? { invalid: true }
                                          : { valid: true }),
                                      })}
                                      required
                                    />
                                    <FormFeedback tooltip>
                                      {props.error.confirm_password}
                                    </FormFeedback>
                                    <Label for="confirm_password">
                                      Confirmar contraseña
                                    </Label>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mt-4 ms-5">
                              <Col lg={4}>
                                <Link
                                  className="btn btn-danger me-4"
                                  to="/users"
                                >
                                  Cancelar
                                </Link>

                                <Button color="success" type="submit">
                                  Actualizar
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>
                      </TabContent>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, userUpdated } = state.User;
  return { error, loading, userUpdated };
};

export default withRouter(connect(mapStateToProps)(UserUpdate));
